<template>
  <main class="not-found-page" aria-labelledby="not-found-title">
    <p class="not-found-page__code">404</p>
    <h1 id="not-found-title">{{ $t('notFoundPage.title') }}</h1>
    <p>{{ $t('notFoundPage.message') }}</p>
    <CustomButton @click="navigateToOverview">
      {{ $t('notFoundPage.overviewButton') }}
    </CustomButton>
  </main>
</template>

<script setup lang="ts">
import { CustomButton } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'

function navigateToOverview(): void {
  navigate('/ueberblick')
}
</script>

<style scoped>
.not-found-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 40rem;
  margin: 4rem auto;
  padding: 0 1rem;
  text-align: center;
}

.not-found-page__code {
  margin: 0;
  font-size: 3rem;
  font-weight: 700;
}
</style>
